import React, { Component } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import StyledActionButton from 'components/layout/StyledActionButton';

const PopupStyle = {
  borderRadius: 5,
  opacity: 0.7,
  padding: '7px'
};

interface Props {
  hoverMessage: string,
  onConfirm?: () => void,
  disabled?: boolean
}

interface State {

}

class SaveActionButton extends Component<Props, State> {

  render(): React.ReactNode {
    const {hoverMessage, onConfirm, disabled = false} = this.props;
    const buttonType = onConfirm ? "button" : "submit";
    return (
        <StyledActionButton
            icon
            type={buttonType}
            onClick={onConfirm}
            disabled={disabled}
        >
          <Popup
              trigger={<Icon name="save outline"/>}
              content={hoverMessage}
              size='small'
              position='top center'
              style={PopupStyle}
              inverted
          />
        </StyledActionButton>
    )
  }

}

export default SaveActionButton;
